// Paths of the published data files, relative to the data root (`apis.dataApi.endpoint`). They mirror the
// pipeline's research/layout.py (WEBDATA section).

/** Symbol search: Id, Symbol, Market, Name of every stock. */
export const symbolsPath = () => "market/list/symbols.json";

/** Stock list page `page` (1-based, by descending market value). */
export const stocksPagePath = (page) => `market/list/stocks-page-${page}.json`;

/** Every group's info and headline aggregates. */
export const groupsIndexPath = () => "groups/index.json";

/** Every file of a stock (`id`: e.g. NYSE-IBM), keyed by file name without `.json`. */
export const stockBundlePath = (id) => `bundles/stocks/${id}.json`;

/** `{ group, insights }` of a group (`id`: e.g. sectors/Technology; the market: indexes/market). */
export const groupBundlePath = (id) => `bundles/groups/${id}.json`;

// The fragmented files the bundles are made of. They are published by the pipeline but not deployed
// (server/data-site/assets/.assetsignore): kept for loading a page's data piece by piece later.

/** One file of a stock (`name`: e.g. valuation, ttm-financials-comparison). */
export const stockFilePath = (id, name) => `stocks/${id}/${name}.json`;

/** Analysis of a group. */
export const groupPath = (id) => `groups/${id}.json`;

/** Insights of a group. */
export const insightsPath = (id) => `insights/${id}.json`;
